import { useQuery } from '@tanstack/react-query';
import { fetchJobs } from '../api/jobsApi.js';

export function useJobs() {
  return useQuery({
    queryKey: ['jobs', 'list'],
    queryFn: fetchJobs,
    refetchInterval: 4000 // temporar până legăm socket
  });
}
